import { Colors } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { ProgramComponentParticipantsTable } from "@/components/pages_logged_in/program/components/program-participants/ProgramComponentParticipantsTable";
import { CARD_CLASSES } from "@/css/constants";
import { MainComponent, MainProgram } from "@/types/programs";

interface ComponentParticipantsProps {
  component: MainComponent;
  initPageSize?: number;
  initStartPage?: number;
  program: MainProgram;
}

export function ComponentParticipants({
  component,
  program,
}: ComponentParticipantsProps) {
  return (
    <Box
      px={[16, 24]}
      py={[16, 24]}
      flex={1}
      className={CARD_CLASSES}
      css={{ background: Colors.WHITE }}
      id={"participant-table"}
    >
      <Box fontSize={18} fontWeight={600}>
        Participants
      </Box>
      <Box mt={24}>
        {/* <Flex
          className="round-corners"
          padding={"3px 0px"}
          width="100%"
          style={{ background: Colors.WHITE }}
        >
          <ProgramParticipantsTable
            participants={programUsers}
            program={program}
            component={component}
            onSort={onSort}
            sort={sort}
            loading={loading}
            canViewResponses={canViewResponses}
            displayColumns={getDisplayColumns(component.type)}
            refetchParticipants={refetchParticipants}
          />
        </Flex>

        <Paging
          style={{ background: Colors.WHITE, padding: 10, marginBottom: 10 }}
          currentPage={currentPage}
          pageSize={pageSize}
          setCurrentPage={(index) => {
            setCurrentPage(index);
          }}
          totalRecords={totalRecords}
          isSticky={true}
        /> */}
        <ProgramComponentParticipantsTable
          program={program}
          component={component}
        />
      </Box>
      {/* <ProgramComponentParticipantsTable
        program={program}
        component={component}
      /> */}
    </Box>
  );
}
